// @ts-nocheck
/* eslint-disable */
export const avlIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 6"><path fill="currentColor" d="M5.948 6H3.842l-.126-1.431H2.051L1.412 6H.54L3.194.285h2.133zm-3.6-2.088h1.305l-.207-2.448zM6.868.285H8.92l.306 3.87 1.872-3.87h.891L9.325 6H7.201zm5.707 0h1.953l-1.062 4.959h1.827L15.14 6h-3.78z"/></svg>`,
    name: 'avl' as const
};